import VersionCheck from './VersionCheck';

export default VersionCheck;
